export default () => {
    return {
        mounted(delay = this.$store.animationDelay, scrollTrigger = true) {
            let stSettings = false;

            if (scrollTrigger) {
                stSettings = {
                    start: 'top 85%',
                    trigger: this.$refs.container
                };
            }

            const zoom = gsap.timeline({ scrollTrigger: stSettings });

            zoom.fromTo(
                this.$refs.background,
                { opacity: 0, scale: 1.5 },
                { duration: 1.1, opacity: 100, scale: 1, delay: delay, ease: 'expo.inOut' }
            );
        }
    };
};
